import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactDOM from 'react-dom';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import globalDyHandler from 'core/utils/helpers/dyHandler';
import { selectIsDesktopMQ } from 'core/modules/MediaQueries/selectors';
import config from './configs';
import StickyFooterButton from './components/StickyFooterButton';
import StickyFooterEmail from './components/StickyFooterEmail';
import { triggerStickyFooterButtonIsToggledGaEvent } from './actions';

import './StickyFooterVendor.scss';

export function StickyFooterVendor() {
  const elementContainer = document.getElementsByClassName('mn_pageBody')[0];

  const [stickyFooterVendorType, setStickyFooterVendorType] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);
  const dispatch = useDispatch();
  const isDesktopMQ = useSelector(selectIsDesktopMQ);

  useEffect(() => {
    globalDyHandler.showStickyFooter = (type) => {
      setStickyFooterVendorType(type);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => setIsExpanded(true), 1000);
  }, []);

  const toggleStickyFooter = () => {
    const toggledIsExpanded = !isExpanded;
    setIsExpanded(toggledIsExpanded);
    dispatch(triggerStickyFooterButtonIsToggledGaEvent(stickyFooterVendorType, isExpanded));
  };

  if (!(stickyFooterVendorType === 'button' || stickyFooterVendorType === 'email') || !isDesktopMQ) {
    return null;
  }

  const classNameVendorType = stickyFooterVendorType === 'button' ? 'mn_stickyFooterButton' : 'mn_stickyFooterEmail';

  return ReactDOM.createPortal(
    <div className="mn_stickyFooterVendorWrap">
      <div className={`mn_stickyFooterVendor ${isExpanded ? 'mn_expanded' : 'mn_collapsed'}`}>
        <div className="mn_stickyFooterVendorContentWrap">
          <button
            className="mn_stickyFooterVendorControl"
            label={`${isExpanded ? 'Hide' : 'Show'} footer`}
            aria-expanded={isExpanded}
            onClick={toggleStickyFooter}
          />
          <ContentWrap>
            <div className={`mn_stickyFooterVendorContent ${classNameVendorType}`}>
              {stickyFooterVendorType === 'button' && <StickyFooterButton config={config} />}
              {stickyFooterVendorType === 'email' && <StickyFooterEmail config={config} />}
            </div>
          </ContentWrap>
        </div>
      </div>
    </div>,
    elementContainer,
  );
}

export default (props) => <ComponentErrorBoundary><StickyFooterVendor {...props} /></ComponentErrorBoundary>;
